import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { GItem } from '@app/cp/shared/models/GItem';
import { process, aggregateBy, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CnstPMConfirmSaveParam } from '@app/cp/shared/models/CnstPMConfirmSaveParam';
import { CnstPMMarkCompleteParam } from '@app/cp/shared/models/CnstPMMarkCompleteParam';
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { PMBoardData } from '@app/cp/shared/models/PMBoardData';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@UseFeatureFlagSet()
@Component({
    selector: 'cp-pm-board',
    templateUrl: './pm-board.component.html',
    styleUrls: ['./pm-board.component.scss'],
    standalone: false
})
export class PmBoardComponent extends BaseGridComponent<PMBoardData, null> implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    public aggregates: any[] = [];
    public aggregateResults;
    public gridView: GridDataResult;
    public pageSize = 15;
    public confirmBtnStyle: string = 'outline';
    public confirmBtnDisabled: boolean = false;
    public confirmBtnLoading: boolean = false;
    public markCompleteBtnDisabled: boolean = false;
    public markCompleteBtnLoading: boolean = false;
    public btnTooltipText;
    customerNameCF: MSCLFilterClass;
    contractAdministratorCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    pmCF: MSCLFilterClass;
    divisionNameCF: MSCLFilterClass;
    isLoadingIndicatorVisible: boolean = true;
    isRestrictedBtnHover: boolean = false;
    subs_dataRefUpdated: Subscription;
    //boardData$: Observable<BoardData[]>;

    //, private boardStore: BoardStore, private boardQuery: BoardQuery
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService, private sanitizer: DomSanitizer) {

        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.skip = 0;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });

        this.aggregates = [
            { field: 'contractNumber', aggregate: 'count' },
            { field: 'jobNumber', aggregate: 'count' },
            { field: 'jobTotal', aggregate: 'sum' },
            { field: 'totalCostsToDate', aggregate: 'sum' },
            { field: 'profitDollars', aggregate: 'sum' },
            { field: 'origEstProfit', aggregate: 'sum' },
            { field: 'estBudget', aggregate: 'sum' },
            { field: 'caTotal', aggregate: 'sum' },
            { field: 'contAdjTotal', aggregate: 'sum' },
            { field: 'contractDollars', aggregate: 'sum' },
            { field: 'bidSale', aggregate: 'sum' },
            { field: 'bidHrs', aggregate: 'sum' },
            { field: 'actHrs', aggregate: 'sum' },
            { field: 'bidCost', aggregate: 'sum' },
            { field: 'jobCost', aggregate: 'sum' },
            { field: 'ogBidSale', aggregate: 'sum' },
            { field: 'ogBidCost', aggregate: 'sum' },
            { field: 'ogJobCost', aggregate: 'sum' },
            { field: 'profit', aggregate: 'sum' },
            { field: 'percComplete', aggregate: 'sum' },
            { field: 'origEstProfit', aggregate: 'sum' }
        ];
    }

    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    referenceData: DQOIReferenceData;
    contractAdministratorId: any;

    gridDataPrime: any[] = [];
    //customerId: any;
    //jobClassIds: any;
    //dispatchStatusIds: any;
    constractNo: string;
    billingMonthYear: any;
    projectManagerId: any;

    //Filters
    jobPMs: GItem[] = [];
    //contractStatuses: GItem[] = [];
    customers: GItem[] = [];
    jobClasses: GItem[] = [];
    jobStatuses: GItem[] = [];
    contractStatuses: GItem[] = [];
    contractPMs: GItem[] = [];
    coordinators: GItem[] = [];
    divisions: GItem[] = [];

    JobPMIds: GItem[] = [];
    dispatchStatusIds: GItem[] = [];
    customerIds: GItem[] = [];
    jobClassIds: GItem[] = [];
    jobStatusIds: GItem[] = [];
    contractStatusIds: GItem[] = [];
    contractPMIds: GItem[] = [];
    coordinatorIds: GItem[] = [];
    divisionsIds: GItem[] = [];
    mgrPMDirectReportsIds: GItem[] = [];

    percCompleteValues: GItem[] = [
        { "description": "Under 75%", "value": 1, "category": null, "reference": null },
        { "description": "75% - 99.99%", "value": 2, "category": null, "reference": null },
        { "description": "100%", "value": 3, "category": null, "reference": null },
        { "description": "Over 100%", "value": 4, "category": null, "reference": null }
    ];
    percCompleteFilterValue: GItem[] = [];
    isTMFilterValues: GItem[] = [
        { "description": "Is T&M Contract Value", "value": true, "category": null, "reference": null },
        { "description": "Not T&M Contract Value", "value": false, "category": null, "reference": null }
    ];
    isTMFilterValue: GItem = null;

    filteredData: any[];
    exportFilteredData: any[];

    ColumnHeaders: ColumnSetting[];
    loading: boolean = false;
    private initSubscription: Subscription;
    private getDataSubscription: Subscription;

    ngOnInit() {
        this.loading = false;
        this.pageSize = 45;

        /* PM Board Performance */
        //this.getData();
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.unsubscribeAll();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    public gridData2: any;// = process(this.gridData, this.state);

    getData() {

        if (this.isLoadingIndicatorVisible) {
            this.loading = true;
        }
        this.totalContractCount = 0;
        let param: ConstructionSearchParam = this.getParam();
        this.svc_data.getPMBoardInfo(param).subscribe((data: BaseMessageInfo) => {
            if (data.primaryReturn && data.primaryReturn.length > 0) {

                let arr = [];
                for (let i = 0; i < data.primaryReturn.length; i++) {
                    let newObj: PMBoardData = new PMBoardData(data.primaryReturn[i]);
                    arr.push(newObj);
                }

                this.gridData = arr;
               // this.gridData = _.cloneDeep(data.primaryReturn);//.slice(0, 5);
                this.filteredData = _.cloneDeep(this.gridData); /* PM Board Performance */
               // this.applyFilters(); /* PM Board Performance */
                this.processGridData();
               // this.PopulateFilters(this.gridData); /* PM Board Performance */
                this.loadEntries();
                //this.gridData2 = process(this.gridData, this.state);

                this.loading = false;
            } else {
                this.gridData = [];
                this.filteredData = _.cloneDeep(this.gridData);
                this.processGridData();
                this.loadEntries();
                this.handleNetworkError(JSON.stringify(data.messages));
                this.loading = false;
            }

        },
            error => this.handleNetworkError(error));

    }

    public dataStateChange(state: DataStateChangeEvent): void {
        super.dataStateChange(state);
        this.processGridData();
        //this.gridData = process(this.data, this.state);
    }

    tagMapper(tags: any[]): any[] {
        return tags.length < 2 ? tags : [tags];
    }

    totalContractCount: number = 0;
    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.state.filter);
        if (CommonFunctions.hasArrayElementValue(this.exportFilteredData)) {
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
        } else {
            this.aggregateResults = [];
        }
        this.totalContractCount = this.filteredData.map(item => item.contractId).filter((value, index, self) => self.indexOf(value) === index).length;
        this.customerNameCF = new MSCLFilterClass('customerName', 'customerName', this.filteredData);
        this.contractAdministratorCF = new MSCLFilterClass('contractAdministrator', 'contractAdministrator', this.filteredData);
        this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.filteredData);
        this.divisionNameCF = new MSCLFilterClass('divisionName', 'divisionName', this.filteredData);
        this.pmCF = new MSCLFilterClass('pm', 'pm', this.filteredData);
        this.loading = false;
        //if (CommonFunctions.hasArrayElementValue(this.gridData)) {
        //    this.aggregateResults = aggregateBy(filterBy(this.gridData, this.state.filter), this.aggregates);
        //}
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    handlePMError(error) {
        this.confirmBtnLoading = false;
        this.confirmBtnDisabled = false;
        this.globals.notifyError('There was a problem saving the Confirmation');
    }

    handleMarkCompleteError(error) {
        this.markCompleteBtnLoading = false;
        this.markCompleteBtnDisabled = false;
        this.globals.notifyError('There was a problem marking the job as Complete');
    }

    showError() {
        this.loading = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }
    clearData() {
        this.gridData = [];
        this.filteredData = [];
        this.processGridData();
        this.loading = false;
    }

    refreshData() {
        this.clearData();
        //this.processGridData();
       // this.getData();  /* PM Board Performance */
    }

    unsubscribeAll() {
        if (this.getDataSubscription) {
            this.getDataSubscription.unsubscribe();
        }
    }

    getParam(initial: boolean = false): ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();

        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.contractAdministratorId = this.contractAdministratorId;
            param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            param.contractNo = this.constractNo;

            /* PM Board Performance */
            param.JobPMIds = this.JobPMIds;
            param.mgrPMDirectReportsIds = this.mgrPMDirectReportsIds;
            param.customerIds = this.customerIds;
            param.jobTypeIds = this.jobStatusIds;
            param.contractStatusIds = this.contractStatusIds;
            param.contractPMIds = this.contractPMIds;
            param.coordinatorIds = this.coordinatorIds;
            param.divisionsIds = this.divisionsIds;
            param.percCompleteFilterValue = this.percCompleteFilterValue;
            if (this.isTMFilterValue) {
                param.hasTMFilterValue = true;
                param.isTMFilterValue = this.isTMFilterValue.value;
            } else {
                param.hasTMFilterValue = false;
                param.isTMFilterValue = false;
            }

            if (this.billingMonthYear != null) {
                param.billingMonthYear = this.billingMonthYear;
            } else {
                param.billingMonthYear = new Date();
                param.billingMonthYear.setDate(1);
            }
        }
        return param;
    }

    applyFilters() {
        this.totalContractCount = 0;
        this.loading = true;
        this.filteredData = [];

        if (this.JobPMIds.length == 0 && this.customerIds.length == 0 && this.jobClassIds.length == 0 && this.jobStatusIds.length == 0
            && this.contractStatusIds.length == 0 && this.contractPMIds.length == 0 && this.coordinatorIds.length == 0 && this.divisionsIds.length == 0
            && this.percCompleteFilterValue.length == 0 && this.isTMFilterValue == null) {
            this.filteredData = _.cloneDeep(this.gridData);
        } else {
            let tempFilteredData = _.cloneDeep(this.gridData);
            if (this.JobPMIds.length > 0) {
                tempFilteredData.forEach(row => {
                    let filterIndex = this.JobPMIds.findIndex((element) => { return element === row.jobPMId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.customerIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.customerIds.findIndex((element) => { return element === row.customerId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.jobClassIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobClassIds.findIndex((element) => { return element === row.jobClassId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.jobStatusIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobStatusIds.findIndex((element) => { return element === row.jobStatusId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.contractStatusIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.contractStatusIds.findIndex((element) => { return element === row.contractStatusId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.contractPMIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.contractPMIds.findIndex((element) => { return element === row.contractPMId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.coordinatorIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.coordinatorIds.findIndex((element) => { return element === row.coordinatorId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.divisionsIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.divisionsIds.findIndex((element) => { return element === row.contractDivisionId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.percCompleteFilterValue.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.percCompleteFilterValue.findIndex((element) => { return element === row.completionPercFilter });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            //if (this.isTMFilterValue.length > 0) {

            //    tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
            //    this.filteredData = [];
            //    tempFilteredData.forEach(row => {
            //        let filterIndex = this.isTMFilterValue.findIndex((element) => { return element === row.tandMStyling });
            //        if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
            //            this.filteredData.push(row);
            //        }
            //    });
            //}
        }
        this.processGridData();
    }

    clearFilters() {
        //this.loading = true;
        this.filteredData = [];
        this.JobPMIds = [];
        this.mgrPMDirectReportsIds = [];
        this.dispatchStatusIds = [];
        this.customerIds = [];
        this.jobClassIds = [];
        this.jobStatusIds = [];
        this.contractStatusIds = [];
        this.contractPMIds = [];
        this.coordinatorIds = [];
        this.divisionsIds = [];
        this.percCompleteFilterValue = [];
        this.isTMFilterValue = null;
       // this.applyFilters(); /* PM Board Performance */
    }

    showAdjustPopup: boolean = false;
    showSOWAdjustPopup: boolean = false;
    currentJobId: any;
    currentJobNumber: any;
    currentSOWJobId: any;
    currentSOWJobNumber: any;

    minimumAdjustment: number;
    openAdjustmentPopup(jobId, jobNum, minAdjust) {
        this.minimumAdjustment = minAdjust;
        this.currentJobId = jobId;
        this.currentJobNumber = jobNum;
        this.showAdjustPopup = true;
    }

    closeAdjustmentPopup() {
        this.minimumAdjustment = null;
        this.currentJobId = null;
        this.currentJobNumber = null;
        this.showAdjustPopup = false;
        //alert('should be getting new data now');
        this.loading = true;
        this.getData();
    }
    openSOWAdjustmentPopup(jobId, jobNum) {
        this.currentSOWJobId = jobId;
        this.currentSOWJobNumber = jobNum;
        this.showSOWAdjustPopup = true;
    }

    closeSOWAdjustmentPopup() {
        this.currentSOWJobId = null;
        this.currentSOWJobNumber = null;
        this.showSOWAdjustPopup = false;
        //alert('should be getting new data now');
        this.loading = true;
        this.getData();
    }
    showCompleteAdjustPopup: boolean = false;
    currentCompleteJobId: any;
    currentCompleteJobNumber: any;
    openCompleteAdjustmentPopup(jobId, jobNum) {
        this.currentCompleteJobId = jobId;
        this.currentCompleteJobNumber = jobNum;
        this.showCompleteAdjustPopup = true;
    }

    closeCompleteAdjustmentPopup() {
        this.currentCompleteJobId = null;
        this.currentCompleteJobNumber = null;
        this.showCompleteAdjustPopup = false;
        //alert('should be getting new data now');
        this.loading = true;
        this.getData();
    }

    pmConfirm(data) {
        this.confirmBtnDisabled = true;
        this.confirmBtnLoading = true;
        let confirmParam = new CnstPMConfirmSaveParam();
        confirmParam.confirmationValues = JSON.stringify(data);
        confirmParam.insertUserId = this.globals.userId;
        confirmParam.pMPersonId = data.contractPMId;
        confirmParam.dispatchId = data.jobId;
        this.svc_data.savePMConfirmation(confirmParam).subscribe((data: BaseMessageInfo) => {
            if (data.primaryReturn.length > 0) {
                this.globals.notifySuccess('Confirmation Saved');
                this.confirmBtnDisabled = false;
                this.confirmBtnLoading = false;
                this.isLoadingIndicatorVisible = false;
                this.getData();
            } else {
                this.handlePMError(JSON.stringify(data.messages));
            }
        },
            error => this.handlePMError(error));
    }
    markComplete(data) {
        this.markCompleteBtnDisabled = true;
        this.markCompleteBtnLoading = true;
        let markCompleteParam = new CnstPMMarkCompleteParam();
        //markCompleteParam.confirmationValues = JSON.stringify(data);
        markCompleteParam.costAdjustmentAmount = 0;
        markCompleteParam.insertUserId = this.globals.userId;
        markCompleteParam.pMPersonId = data.contractPMId;
        markCompleteParam.dispatchId = data.jobId;
        this.svc_data.savePMMarkComplete(markCompleteParam).subscribe((data: BaseMessageInfo) => {
            if (data.primaryReturn.length > 0) {
                this.globals.notifySuccess('Job Marked as Complete');
                this.markCompleteBtnDisabled = false;
                this.markCompleteBtnLoading = false;
                this.getData();
            } else {
                this.handleMarkCompleteError(JSON.stringify(data.messages));
            }
        },
            error => this.handleMarkCompleteError(error));
    }

    confirmButtonStyle(dataItem) {
        let confirmDate = dataItem.lastConfirmDt;
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var currentMonth = currentDate.getMonth();
        var currentDay = currentDate.getDate();
        var testDate = new Date(confirmDate);
        var confirmYear = testDate.getFullYear();
        var confirmMonth = testDate.getMonth();
        var confirmDay = testDate.getDate();

        switch ((Math.abs(confirmMonth - currentMonth) == 0) && (Math.abs(confirmYear - currentYear) == 0)) {
            case true:
                return 'outline';
            //has been confirmed this month
            case false:
                return 'solid';
            //needs confirmation
        }
    }
    confirmButtonLastConfirmMonth(confirmDate) {
        var testDate = new Date(confirmDate);
        var confirmMonth = testDate.getMonth();
        return confirmMonth;
    }
    confirmButtonCurrentMonth(confirmDate) {
        var currentDate = new Date();
        var currentMonth = currentDate.getMonth();
        return currentMonth;
    }

    confirmButtonDisabled(dispatchPM) {
        switch (dispatchPM == this.globals.personId) {
            case true:
                return false;
            case false:
                return true;
        }
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    public PopulateFilters(data: any) {
        data.forEach(item => {
            if (this.jobPMs.findIndex((element) => { return element.value === item.jobPMId }) == -1) {
                if (this.jobPMs.findIndex(a => a.value == item.jobPMId) < 0) {
                    this.jobPMs.push({ description: item.jobPM, value: item.jobPMId, category: null, "reference": null })
                }
            }
            if (this.customers.findIndex((element) => { return element.value === item.customerId }) == -1) {
                if (this.customers.findIndex(a => a.value == item.customerId) < 0) {
                    this.customers.push({ description: item.customerName, value: item.customerId, category: null, "reference": null })
                }
            }
            if (this.jobClasses.findIndex((element) => { return element.value === item.jobClassId }) == -1) {
                if (this.jobClasses.findIndex(a => a.value == item.jobClassId) < 0) {
                    this.jobClasses.push({ description: item.jobClassName, value: item.jobClassId, category: null, "reference": null })
                }
            }
            if (this.jobStatuses.findIndex((element) => { return element.value === item.jobStatusId }) == -1) {
                if (this.jobStatuses.findIndex(a => a.value == item.jobStatusId) < 0) {
                    this.jobStatuses.push({ description: item.jobStatusName, value: item.jobStatusId, category: null, "reference": null })
                }
            }
            if (this.contractStatuses.findIndex((element) => { return element.value === item.contractStatusId }) == -1) {
                if (this.contractStatuses.findIndex(a => a.value == item.contractStatusId) < 0) {
                    this.contractStatuses.push({ description: item.contractStatusName, value: item.contractStatusId, category: null, "reference": null })
                }
            }
            if (this.contractPMs.findIndex((element) => { return element.value === item.contractPMId }) == -1) {
                if (this.contractPMs.findIndex(a => a.value == item.contractPMId) < 0) {
                    this.contractPMs.push({ description: item.contractPM, value: item.contractPMId, category: null, "reference": null })
                }
            }
            if (this.coordinators.findIndex((element) => { return element.value === item.coordinatorId }) == -1) {
                if (this.coordinators.findIndex(a => a.value == item.coordinatorId) < 0) {
                    this.coordinators.push({ description: item.coordinatorName, value: item.coordinatorId, category: null, "reference": null })
                }
            }
            if (this.divisions.findIndex((element) => { return element.value === item.contractDivisionId }) == -1) {
                if (this.divisions.findIndex(a => a.value == item.contractDivisionId) < 0) {
                    this.divisions.push({ description: item.divisionName, value: item.contractDivisionId, category: null, "reference": null })
                }
            }
        });
        this.jobPMs.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.customers.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.jobClasses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.jobStatuses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.contractStatuses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.contractPMs.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.coordinators.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.divisions.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadEntries();
    }

    public rowCallback = (context: RowClassArgs) => {
        switch (true) {
            //green
            case (context.dataItem.completionPerc <= 0.75):
                return { green: true };
            //yellow
            case (context.dataItem.completionPerc > 0.75 && context.dataItem.completionPerc < 1):
                return { yellow: true };
            //grey
            case (context.dataItem.completionPerc == 1):
                return { grey: true };
            //red
            case (context.dataItem.completionPerc > 1):
                return { red: true };
        }
    };

    private loadEntries(): void {
        this.gridView = {
            data: this.filteredData.slice(this.skip, this.skip + this.pageSize),
            total: this.filteredData.length
        };
    }

    public expandDetail() {
        return true;
    }

    public filter: CompositeFilterDescriptor;
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        this.isRestrictedBtnHover = false;
        let eVal = element.innerHTML.includes('aria-disabled="true"');

        if (element.nodeName === "TD" || element.nodeName === 'TH') {
            if (element.offsetWidth < element.scrollWidth) {
                this.tooltipDir.toggle(element);
            } else {
                if ((element.nodeName === 'TD' || element.nodeName === 'TH') && eVal)
                {
                    this.isRestrictedBtnHover = true;
                    this.btnTooltipText = "Budget overspent. An adjustment is required in order to confirm/acknowledge this job's expenses.";
                    this.tooltipDir.toggle(element);
                }
            }

        } else {
            this.tooltipDir.hide();
        }
    }

    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.exportFilteredData as any, {}).data,
        };
        return result;
    }

    public colorCode(dataItem: any): SafeStyle {
        let result;

        switch (dataItem.tandMStyling) {
            case true:
                result = "#B3D3F2";
                break;
            case false:
                result = "transparent";
                break;
            default:
                result = "transparent";
                break;
        }

        return this.sanitizer.bypassSecurityTrustStyle(result);
    }
}
